import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

import { CustomEmailValidator } from '@core/services/media.service';
import { SendoutModalData } from '@shared/components/modals/email-sendout.model';

@Component({
  selector: 'flow-email-sendout-modal',
  templateUrl: './email-sendout-modal.component.html',
  styleUrls: ['./email-sendout-modal.component.scss'],
})
export class EmailSendoutModalComponent implements OnInit {
  readonly sendRequested$ = new Subject<string[]>();

  isSending = false;
  invalidRecipients: string[] = [];

  modalTitle: string;
  modalDescription: string | null;
  modalSubmitLabel: string;

  form = this.fb.group({
    emailRecipients: this.fb.array<FormControl<string | null>>([]),
    createSeparateMediaPdfs: [true],
  });

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EmailSendoutModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SendoutModalData
  ) {}

  get emailRecipients(): FormArray<FormControl<string | null>> {
    return this.form.get('emailRecipients') as FormArray<FormControl<string | null>>;
  }

  get createSeparateMediaPdfs() {
    return this.form.get('createSeparateMediaPdfs');
  }

  ngOnInit(): void {
    this.modalTitle = this.data?.title || 'campaign.sendouts.manual.title';
    this.modalDescription = this.data?.description || null;
    this.modalSubmitLabel = this.data?.submitLabel || 'global.send';

    if (!this.emailRecipients.length) {
      this.emailRecipients.push(this.createEmailControl());
    }
  }

  private createEmailControl(): FormControl<string | null> {
    return this.fb.control<string | null>('', [Validators.required, CustomEmailValidator()]);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSend(): void {
    if (this.form.invalid) {
      this.emailRecipients.markAllAsTouched();
      return;
    }

    const emails = (this.emailRecipients.value || []).filter(email => !!email) as string[];
    if (!emails.length) return;

    this.invalidRecipients = [];
    this.isSending = true;
    this.sendRequested$.next(emails);

    if (this.data.closeOnSend) {
      this.dialogRef.close({
        emailRecipients: emails,
        createSeparateMediaPdfs: !!this.createSeparateMediaPdfs?.value,
      });
    }
  }

  trackByIndex(index: number): number {
    return index;
  }

  close(result?: unknown): void {
    this.dialogRef.close(result);
  }
}
